import React from "react";
import PropTypes from 'prop-types';

const Circle = ({ text }) => (
    <svg viewBox="0 0 100 100" >
        <circle cx="50" cy="50" r="47" />
        <text x="50" y="50" textAnchor="middle" fontSize="50" alignmentBaseline="central">{text}</text>
    </svg>
);

Circle.propTypes = {
    text: PropTypes.number.isRequired
};

export default Circle;